export const Endpoint = () => `/api/v3/celery/addcrontabtask`;
export const Csrf = () => `/api/v3/celery/token/`;
export declare const QueryKey: never;
export type Payload = {
    name: string;
    task: string;
    taskType: string;
    crontab: string;
};
export type Response = void;
